import {
  Box,
  CircularProgress,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

function LoadingMedicine() {
  const { colors } = useCelleraTheme();
  return (
    <TableRow>
      <TableCell colSpan={5} sx={{ border: "none" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "450px",
            gap: 2,
          }}
        >
          <CircularProgress
            size={40}
            sx={{
              color: colors.secondary.main,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontSize: "0.875rem",
            }}
          >
            Loading medicines...
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default LoadingMedicine;
